export const REASON_CODES = {
  VALIDATION_FAILED: 101,
  AUTHORIZATION_ERROR: 401,
  NOT_FOUND: 404
};
